var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var RedMarker = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  width: 10px;\n  height: 10px;\n  background-color: ", ";\n  border-radius: 100px;\n"], ["\n  display: block;\n  width: 10px;\n  height: 10px;\n  background-color: ",
    ";\n  border-radius: 100px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.generalContent.text.danger.color;
});
var templateObject_1;
//# sourceMappingURL=RedMarker.js.map